module.exports = __webpack_public_path__ + "img/监测指标.9ad79dbe.png";